import { Observable } from 'rxjs';

import { Action } from './action';

const effectQueue: Observable<Action>[] = [];
// To maintain similiarity to NgRx
export function createEffect(effect: () => Observable<Action>) {
  // Hacky workaround for not having a better effect creation pipeline.
  // Doesn't really matter since this will be replaced with NgRx
  effectQueue.push(effect());
}

export function flushEffectQueue(dispatcher: (action: Action) => void) {
  effectQueue.forEach((effect) => effect.subscribe((action) => dispatcher(action)));
  effectQueue.length = 0;
}
